const HYPGRAPH_MEDIA_REGX = /^https:\/\/media.graphassets.com\//;

const MAX = 1280;

export const resizeImageMaxSize = (imageUrl: string) => {
  if (!HYPGRAPH_MEDIA_REGX.test(imageUrl)) {
    return imageUrl;
  }

  const imgUrlObj = new URL(imageUrl);
  return `${imgUrlObj.origin}/resize=fit:max,width:${MAX},height:${MAX}${imgUrlObj.pathname}`;
};
